export interface CompanyRegistrationRequestModel {
  email: string;
  companyName: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  street: string;
  houseNumber: string;
  zip: string;
  city: string;
  country?: string;
  acceptDataProtection: boolean;
  acceptTermsOfUse: boolean;
  utmSource?: string | null;
  utmCampaign?: string | null;
}

export interface CompanyRegistrationResponseModel {
  companyId: number;
  adminUserId: string;
}
